import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getMembershipTierChrome,
  type MembershipTierId,
} from './membershipTierChrome';
import './MembershipTierChrome.css';

type Props = {
  tier: MembershipTierId | string | undefined | null;
  /** When false, render as a non-clickable span */
  clickable?: boolean;
  className?: string;
};

/** Tier wordmark pill — distinct fonts per Bronze / Silver / Gold. */
export const MembershipTierBadge: React.FC<Props> = ({
  tier,
  clickable = true,
  className = '',
}) => {
  const navigate = useNavigate();
  const chrome = getMembershipTierChrome(tier);
  if (!chrome) return null;

  const classes = `mt-tier-label mt-tier-label--${chrome.id} ${className}`.trim();

  if (!clickable) {
    return <span className={classes}>{chrome.label}</span>;
  }

  return (
    <button
      type="button"
      className={classes}
      onClick={() => navigate('/membership')}
      aria-label={`${chrome.label} membership`}
      title={`Your ${chrome.label} membership`}
    >
      {chrome.label}
    </button>
  );
};

export default MembershipTierBadge;
